const price = (value) => Number.isFinite(value) ? `$${value.toLocaleString("en-US", { maximumFractionDigits: 12 })}` : "—";
export const candleTime = (timestamp) => new Date(timestamp * 1000).toISOString().replace("T", " ").slice(0, 16) + " UTC";

export const ChartLegend = ({ candle, prefix }) => <div className="market-legend" data-testid={`${prefix}-chart-legend`}>
  <dl>{[["open", "O"], ["high", "H"], ["low", "L"], ["close", "C"], ["volume", "VOL"]].map(([key, label]) => <div key={key}>
    <dt>{label}</dt><dd data-testid={`${prefix}-chart-${key}`}>{price(candle?.[key])}</dd>
  </div>)}</dl>
  <span data-testid={`${prefix}-chart-candle-time`}>{candle ? candleTime(candle.time) : "USD · UTC"}</span>
</div>;